const copyURLToClipboard = () => {
  if (document.querySelector(".js-copy-link") === null) {
    return;
  }
  const copyLink = document.querySelector(".js-copy-link");
  const dummy = document.createElement("input");
  const text = window.location.href;

  copyLink.addEventListener("click", () => {
    document.body.appendChild(dummy);
    dummy.value = text;
    dummy.select();
    document.execCommand("copy");
    document.body.removeChild(dummy);
    console.log("COPY");
  });
};

export default copyURLToClipboard;
